import { CSSProperties, PropsWithChildren } from 'react';

export default function IntercomTarget({
	children,
	target,
	style,
	disabled = false,
	block = false,
}: PropsWithChildren<{
	target: string;
	style?: CSSProperties;
	disabled?: boolean;
	block?: boolean;
}>) {
	if (disabled) {
		return <div style={{ display: block ? 'block' : 'inline-block', ...style }}>{children}</div>;
	}

	return (
		<div
			style={{ display: block ? 'block' : 'inline-block', ...style }}
			data-intercom-target={target}
		>
			{children}
		</div>
	);
}
